import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from "react-data-table-component";
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from "react-promise-tracker";
import Select from "react-select";
import Popup from "react-popup";
import FacturaElectronicaService from "../../../services/consultas/FacturaElectronicaService";
import { formatoSeparadorMilesReturn, separadorPuntoMiles } from "../../generico/utils/FormatoInput";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class FacturaElectronica extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaFactura: [],
      listaPeriodo: [],
      periodoElegido: null,
    };
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });
  
  componentDidMount() {
    this.obtenerPeriodo();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerPeriodo = () => {
    var lista = [];
    lista.push({
      value: null,
      label: "--Seleccione--",
    });

    var now = new Date();
    var mes = now.getMonth() + 1;
    var anio = now.getFullYear();

    var mesChar = "";
    for (var i = 0; i < 18; i++) {
      if (mes === 0) {
        mes = 12;
        anio = anio - 1;
      }
      mesChar = mes.toString().length === 1 ? "0" + mes : mes;
      lista.push({
        value: mesChar + "/" + anio,
        label: mesChar + "/" + anio,
      });
      mes = mes - 1;
    }
    this.setState({ listaPeriodo: lista });
    return lista;
  };

  dibujarListaFactura() {
    if (this.state.listaFactura.length === 0) {
      return <div></div>;
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <DatosSocio />
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={this.getColumn()}
                      data={this.state.listaFactura}
                      dense={true}
                      striped={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="no hay registros para mostrar"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChangeSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        listaFactura: [],
        periodoElegido : null
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value,
      });
    }
  };

  getColumn() {
    return [
      {
        name: "Fecha",
        selector: row => row.fechaFactura,
        //width: "100px",
      },
      {
        name: "Tipo Documento",
        selector: row => row.tipoDocumento,
        //width: "150px",
      },
      {
        name: "CDC",
        selector: row => row.cdc,
        //width: "150px",
      },
      {
        name: "Importe",
        selector: row => row.importe,
        //width: "100px",
      },
      {
        cell: (row) => (
          <div>
            <button
              ref={() => this.facturaSel}
              id={
                row.tipoDocumento +
                "#" +
                row.cdc +
                "#" +
                row.importe
              }
              key={row.id}
              className="btn btn-xs btn-outline-success"
              value={row.id}
              target="_blank"
              onClick={(evt) => {
                this.facturaSel = evt.currentTarget;
                var campos = this.facturaSel.id.split("#");

                this.descargar(
                  campos[1]
                );
              }}
            >
              {" "}
              <i className="fa fa-download" /> <b>Descargar</b>
            </button>
          </div>
        ),
      },
    ];
  }

  descargar = async (mes, anho) => {
    await trackPromise(
      FacturaElectronicaService.descagarFactura(mes, anho)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };
  obtenerListaFactura = async () => {  
  
    if (this.state.periodoElegido !== null) {
      var anioMes;
      anioMes = this.state.periodoElegido.split("/");

      var listaFactura = [];
      await trackPromise(
        FacturaElectronicaService.obtenerListadoFacturas(
          parseInt(anioMes[0]),
          parseInt(anioMes[1])
        )
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);

            var resultados = jsonData.datosRespuesta;

            if (jsonData.codigoRespuesta === "0") {
              for (var i = 0; i < resultados.length; i++) {
                listaFactura.push({
                  fechaFactura: resultados[i].fechaFactura,
                  tipoDocumento: resultados[i].tipoDocumento,
                  cdc: resultados[i].cdc,
                  importe: separadorPuntoMiles(resultados[i].importe),
                });
              }
              if(resultados.length===0){
                Popup.queue(this.notifiPopup("Info", "No existen facturas en el mes seleccionado"));
                return;
              }
            } else {
              Popup.queue(this.notifiPopup("Info", jsonData.mensajeRespuesta));
              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );

      this.setState({ listaFactura: listaFactura });
    }
  };

  render() {
    var periodo = this.state.listaPeriodo;

    return (
      <div className="content-wrapper">
        <Titulo texto="Impresión de Facturas Electrónicas" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card"  style={{zIndex:"1"}}>
                  <div className="card-body">
                    <div className="row">
                    <div className="col-md-12">
                      <label className="input-label-bold">Mes *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangeSelector}
                            options={periodo}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6" >
                      <button
                          className="btn btn-cu-primary"
                          onClick={() => this.obtenerListaFactura()}
                        >
                        <FontAwesomeIcon icon={faCheck} /> Consultar
                        </button>
                      </div>
                    </div>
                  </div>
                
                </div>
              </div>
            </div>
            {this.dibujarListaFactura()}
          </div>
        </section>
      </div>
    );
  }
}
